/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import HeaderOne from "../../../common/header/HeaderOne";
import FooterOne from "../../../common/footer/FooterOne";

import case1 from "../../../../src/app/assets/images/casestudy//1.png";
import case2 from "../../../../src/app/assets/images/casestudy/2.png";
import case3 from "../../../../src/app/assets/images/casestudy/3.png";
import case4 from "../../../../src/app/assets/images/casestudy/4.png";
import case5 from "../../../../src/app/assets/images/casestudy/5.png";
import case6 from "../../../../src/app/assets/images/casestudy/6.png";
import case7 from "../../../../src/app/assets/images/casestudy/7.png";
import case8 from "../../../../src/app/assets/images/casestudy/8.png";
import case9 from "../../../../src/app/assets/images/casestudy/9.png";
import case10 from "../../../../src/app/assets/images/casestudy/10.png";
import case11 from "../../../../src/app/assets/images/casestudy/11.png";
import case12 from "../../../../src/app/assets/images/casestudy/12.png";
import case13 from "../../../../src/app/assets/images/casestudy/13.png";
import case14 from "../../../../src/app/assets/images/casestudy/14.png";
import case15 from "../../../../src/app/assets/images/casestudy/15.png";
import case16 from "../../../../src/app/assets/images/casestudy/16.png";
import case17 from "../../../../src/app/assets/images/casestudy/17.png";
import case18 from "../../../../src/app/assets/images/casestudy/18.png";
import case19 from "../../../../src/app/assets/images/casestudy/19.png";
import case20 from "../../../../src/app/assets/images/casestudy/20.png";
import case21 from "../../../../src/app/assets/images/casestudy/21.png";
import case22 from "../../../../src/app/assets/images/casestudy/22.png";
import case23 from "../../../../src/app/assets/images/casestudy/23.png";
import case24 from "../../../../src/app/assets/images/casestudy/24.png";
import case25 from "../../../../src/app/assets/images/casestudy/25.png";
import case26 from "../../../../src/app/assets/images/casestudy/26.png";
import case27 from "../../../../src/app/assets/images/casestudy/27.png";
import case28 from "../../../../src/app/assets/images/casestudy/28.png";

const products = () => {
  return (
    <div className="case-study-page">
      <HeaderOne />
      <section class="case-study-bg d-flex align-items-center justify-content-center banner-sec bg-img inner pt-5 section-padding margin-minus">
        <div class="container custom-cn-width">
          <div class="row align-items-center text-center">
            <div class="col-lg-12">
              <h2 class="pb-lg-5 pb-4 position-relative text-white">
                Case Studies
              </h2>
            </div>
          </div>
          <div class="row g-lg-5 g-4 text-start justify-content-lg-end justify-content-center case-list">
            <div class="col-xl-12">
              <div class="row align-items-lg-center justify-content-center">
                <div class="col-lg-2 col-md-12">
                  <div class="row">
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box transition">
                        <div class="icon">
                          <img
                            src={case1}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="fura">Fura</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="fura"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box transition">
                        <div class="icon">
                          <img
                            src={case2}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="iledger">iLedger</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="iledger"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case3}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="geni">Genie</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="geni"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case4}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="practica">Practica</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="practica"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box transition">
                        <div class="icon">
                          <img
                            src={case5}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="mergers-and-acquisition-firm">
                          Merger and Acquisition Firm
                        </a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="mergers-and-acquisition-firm"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case6}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="logistics-company">Logistics Company </a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="logistics-company"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-12">
                  <div class="row">
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class=" case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case7}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="attesta">Attesta</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="attesta"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class=" case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case8}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="hireharmony">Hire Harmony</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="hireharmony"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case9}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="workflow-management-system">
                          Workflow Management System{" "}
                        </a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="workflow-management-system"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case10}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="medico-view-desk-system">Medico- View Desk </a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="medico-view-desk-system"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12  d-sm-block d-md-none d-lg-block">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case11}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="narrative-medical-record-summaries">
                          Narrative Medical Record Summaries
                        </a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="narrative-medical-record-summaries"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-12">
                  <div class="row">
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class=" case-box transition">
                        <div class="icon">
                          <img
                            src={case12}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="frontera">Frontera</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="frontera"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class=" case-box transition">
                        <div class="icon">
                          <img
                            src={case13}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="j&amp;p">J&amp;P</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="j&amp;p"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box transition">
                        <div class="icon">
                          <img
                            src={case14}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="tracky">Tracky</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="tracky"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box transition">
                        <div class="icon">
                          <img
                            src={case15}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="skoolers">Skoolers</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="skoolers"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box transition">
                        <div class="icon">
                          <img
                            src={case16}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="panera-bread">Panera Bread</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="panera-bread"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case17}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="liti-code-system">Liti-code System</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="liti-code-system"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-12">
                  <div class="row">
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class=" case-box transition">
                        <div class="icon">
                          <img
                            src={case18}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="ai-driven-optimization-of-prescription-fulfillment">
                          AI-Driven Optimization of Prescription Fulfillment
                        </a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="ai-driven-optimization-of-prescription-fulfillment"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class=" case-box transition">
                        <div class="icon">
                          <img
                            src={case19}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="intellicue">Intellicue</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="intellicue"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box transition">
                        <div class="icon">
                          <img
                            src={case20}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="medico-risk-chart-app-system">
                          Medico – Risk Chart App
                        </a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="medico-risk-chart-app-system"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box transition">
                        <div class="icon">
                          <img
                            src={case21}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="medico-ai-chrono-sort-app-attesta-system">
                          Medico AI – Chrono Sort App (Attesta)
                        </a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="medico-ai-chrono-sort-app-attesta-system"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case22}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="e-sort-desk-system">E-Sort Desk </a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="e-sort-desk-system"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-12">
                  <div class="row">
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class=" case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case23}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="clued-in-closet">Clued.in Closet</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="clued-in-closet"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class=" case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case24}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="bussopi">Bussopi</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="bussopi"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case25}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="sunbelt">Sunbelt</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="sunbelt"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case26}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="reeler">Reeler</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="reeler"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case27}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="helpfindingmyagent">Help Finding My Agent</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="helpfindingmyagent"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <div class="case-box mt- transition">
                        <div class="icon">
                          <img
                            src={case28}
                            alt="team"
                            class="img-fluid mb-1 mt-4"
                          />
                        </div>
                        <a href="jugl">Jugl</a>
                        <a
                          class="d-inline-block underline-border mt-4"
                          href="jugl"
                        >
                          <span class="border-line d-inline-block me-1">
                            Learn more
                          </span>
                          <i class="fa fa-arrow-right fa-sm position-relative"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="pb-0">
        <div class="container custom-cn-width section-padding pb-0">
          <div class="row g-xl-5 g-4 align-items-center justify-content-center text-center">
            <div class="col-xxl-7 col-xl-8 col-lg-9">
              <h1 class="fw-light mb-lg-4 mb-3 text-dark">
                Discover the CAP Digisoft Difference
              </h1>
              <p class="px-lg-5 text-dark font-size-17">
                Our highly-skilled, cost-effective, expert global resources
                bring the highest quality development standards at competitive
                pricing without the need to make any compromises.
              </p>
              <a
                href="javascript:;"
                class="btn cust-btn-primary secondary-main mt-lg-4 mt-3"
                data-bs-toggle="modal"
                data-bs-target="#meeting"
              >
                Let's Talk
              </a>
            </div>
          </div>
        </div>
      </section>
      <section class="pb-0 section-padding">
        <div class="container">
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-12">
              <hr class="my-0" />
            </div>
          </div>
        </div>
      </section>
      <section class="other-sec section-padding">
        <div class="container custom-cn-width">
          <div class="row g-xl-5 g-4 text-center">
            <div class="col-lg-12 mb-lg-5 mb-4">
              <h1 class="fw-light">Other Solutions</h1>
            </div>
          </div>
          <div class="">
            <div class="row g-4 g-xl-5 text-center text-xl-start">
              <div class="col-lg-4 col-md-6">
                <fieldset class="transition">
                  <legend class="text-xl-start">marketing</legend>
                  <div class="d-flex flex-column justify-content-between h-100">
                    <h4 class="transition mb-2 mb-lg-3">
                      Marketing and Consulting Services
                    </h4>
                    <a
                      class="d-inline-block underline-border"
                      href="marketing-and-consulting"
                    >
                      <span class="border-line d-inline-block me-1">
                        Learn more
                      </span>
                      <i class="fa fa-arrow-right fa-sm position-relative"></i>
                    </a>
                  </div>
                </fieldset>
              </div>

              <div class="col-lg-4 col-md-6">
                <fieldset class="transition">
                  <legend class="text-xl-start">Software</legend>
                  <div class="d-flex flex-column justify-content-between h-100">
                    <h4 class="transition mb-2 mb-lg-3">
                      Mobile App &amp; Software Development
                    </h4>
                    <a
                      class="d-inline-block underline-border"
                      href="mobile-software_development"
                    >
                      <span class="border-line d-inline-block me-1">
                        Learn more
                      </span>
                      <i class="fa fa-arrow-right fa-sm position-relative"></i>
                    </a>
                  </div>
                </fieldset>
              </div>
              <div class="col-lg-4 col-md-6">
                <fieldset class="transition">
                  <legend class="text-xl-start">KPO</legend>
                  <div class="d-flex flex-column justify-content-between h-100">
                    <h4 class="transition mb-2 mb-lg-3">
                      Knowledge Process Outsourcing
                    </h4>
                    <a
                      class="d-inline-block underline-border"
                      href="comprehensive-website-design"
                    >
                      <span class="border-line d-inline-block me-1">
                        Learn more
                      </span>
                      <i class="fa fa-arrow-right fa-sm position-relative"></i>
                    </a>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterOne />
    </div>
  );
};

export default products;
